import call from "@kinetics254/cassandra-base/service/http";
import constants from "./ProfileConstants";

export default {
  namespaced: true,
  state: {
    employee: [],
  },
  mutations: {
    SET_EMPLOYEE: (state, payload) => {
      state.employee = payload;
    },
  },
  getters: {
    employee: (state) => state.employee,
  },
  actions: {
    getEmployee: ({ commit }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.leaveEmployee(data.employeeNo)).then((res) => {
        commit("loader/SET_LOADING", false, { root: true });
        commit("SET_EMPLOYEE", res.data.data);
      });
    },
  },
};
